import * as z from "zod";

export const getRechargeIntegration = {
  name: "getRechargeIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    // Credentials are write-only: never returned, only whether one is stored.
    hasApiToken: z.boolean().optional(),
    hasClientSecret: z.boolean().optional(),
  }),
};
